const utilities = [
  {
    link: 'height',
    name: 'height',
    scroll: 'scroll',
    property: 'height',
    example: 'h-10 sm-h-12 md-h-20 lg-h-56 xl-w-72',
    usage: {
      syntax: 'h-{number}',
      nameClass: 'height',
      properties: ['h-10', 'h-20', 'h-32', 'h-40'],
    },
    values: [
      {
        utility: 'h-0',
        value: '0px',
      },
      {
        utility: 'h-1',
        value: '4px',
      },
      {
        utility: 'h-2',
        value: '16px',
      },
      {
        utility: 'h-3',
        value: '24px',
      },
      {
        utility: 'h-4',
        value: '32px',
      },
      {
        utility: 'h-5',
        value: '40px',
      },
      {
        utility: 'h-6',
        value: '48px',
      },
      {
        utility: 'h-7',
        value: '56px',
      },
      {
        utility: 'h-8',
        value: '64px',
      },
      {
        utility: 'h-9',
        value: '72px',
      },
      {
        utility: 'h-10',
        value: '80px',
      },
      {
        utility: 'h-11',
        value: '88px',
      },
      {
        utility: 'h-12',
        value: '96px',
      },
      {
        utility: 'h-13',
        value: '104px',
      },
      {
        utility: 'h-14',
        value: '112px',
      },
      {
        utility: 'h-15',
        value: '120px',
      },
      {
        utility: 'h-16',
        value: '128px',
      },
      {
        utility: 'h-17',
        value: '136px',
      },
      {
        utility: 'h-18',
        value: '144px',
      },
      {
        utility: 'h-19',
        value: '160px',
      },
      {
        utility: 'h-20',
        value: '176px',
      },
      {
        utility: 'h-21',
        value: '192px',
      },
      {
        utility: 'h-22',
        value: '208px',
      },
      {
        utility: 'h-23',
        value: '224px',
      },
      {
        utility: 'h-24',
        value: '240px',
      },
      {
        utility: 'h-28',
        value: '272px',
      },
      {
        utility: 'h-32',
        value: '300px',
      },
      {
        utility: 'h-36',
        value: '320px',
      },
      {
        utility: 'h-40',
        value: '360px',
      },
      {
        utility: 'h-48',
        value: '416px',
      },

      {
        utility: 'h-56',
        value: '480px',
      },
      {
        utility: 'h-60',
        value: '560px',
      },

      {
        utility: 'h-68',
        value: '240px',
      },
      {
        utility: 'h-72',
        value: '672px',
      },

      {
        utility: 'h-80',
        value: '864px',
      },

      {
        utility: 'h-88',
        value: '896px',
      },
      {
        utility: 'h-96',
        value: '960px',
      },
      {
        utility: 'h-100',
        value: '1000px',
      },
      {
        utility: 'h-1--2',
        value: '50%',
      },
      {
        utility: 'h-1--4',
        value: '25%',
      },
      {
        utility: 'h-2--4',
        value: '50%',
      },
      {
        utility: 'h-3--4',
        value: '75%',
      },
      {
        utility: 'h-1--5',
        value: '20%',
      },
      {
        utility: 'h-2--5',
        value: '40%',
      },
      {
        utility: 'h-3--5',
        value: '60%',
      },
      {
        utility: 'h-4--5',
        value: '80%',
      },
      {
        utility: 'h-full',
        value: '100%',
      },
      {
        utility: 'h-vh',
        value: '100vh',
      },
    ],
  },
  {
    link: 'width',
    property: 'width',
    name: 'width',
    scroll: 'scroll',
    example: 'w-10 sm-w-12 md-w-20 lg-w-56 xl-w-72',
    usage: {
      syntax: 'w-{number}',
      nameClass: 'width',
      properties: ['w-10', 'w-20', 'w-32', 'w-40'],
    },
    values: [
      {
        utility: 'w-0',
        value: '0px',
      },
      {
        utility: 'w-1',
        value: '4px',
      },
      {
        utility: 'w-2',
        value: '16px',
      },
      {
        utility: 'w-3',
        value: '24px',
      },
      {
        utility: 'w-4',
        value: '32px',
      },
      {
        utility: 'w-5',
        value: '40px',
      },
      {
        utility: 'w-6',
        value: '48px',
      },
      {
        utility: 'w-7',
        value: '56px',
      },
      {
        utility: 'w-8',
        value: '64px',
      },
      {
        utility: 'w-9',
        value: '72px',
      },
      {
        utility: 'w-10',
        value: '80px',
      },
      {
        utility: 'w-11',
        value: '88px',
      },
      {
        utility: 'w-12',
        value: '96px',
      },
      {
        utility: 'w-13',
        value: '104px',
      },
      {
        utility: 'w-14',
        value: '112px',
      },
      {
        utility: 'w-15',
        value: '120px',
      },
      {
        utility: 'w-16',
        value: '128px',
      },
      {
        utility: 'w-17',
        value: '136px',
      },
      {
        utility: 'w-18',
        value: '144px',
      },
      {
        utility: 'w-19',
        value: '160px',
      },
      {
        utility: 'w-20',
        value: '176px',
      },
      {
        utility: 'w-21',
        value: '192px',
      },
      {
        utility: 'w-22',
        value: '208px',
      },
      {
        utility: 'w-23',
        value: '224px',
      },
      {
        utility: 'w-24',
        value: '240px',
      },
      {
        utility: 'w-28',
        value: '272px',
      },
      {
        utility: 'w-32',
        value: '300px',
      },
      {
        utility: 'w-36',
        value: '320px',
      },
      {
        utility: 'w-40',
        value: '360px',
      },
      {
        utility: 'w-48',
        value: '416px',
      },

      {
        utility: 'w-56',
        value: '480px',
      },
      {
        utility: 'w-60',
        value: '560px',
      },

      {
        utility: 'w-68',
        value: '240px',
      },
      {
        utility: 'w-72',
        value: '672px',
      },

      {
        utility: 'w-80',
        value: '864px',
      },

      {
        utility: 'w-88',
        value: '896px',
      },
      {
        utility: 'w-96',
        value: '960px',
      },
      {
        utility: 'w-100',
        value: '1000',
      },
      {
        utility: 'w-1--2',
        value: '50%',
      },
      {
        utility: 'w-1--4',
        value: '25%',
      },
      {
        utility: 'w-2--4',
        value: '50%',
      },
      {
        utility: 'w-3--4',
        value: '75%',
      },
      {
        utility: 'w-1--5',
        value: '20%',
      },
      {
        utility: 'w-2--5',
        value: '40%',
      },
      {
        utility: 'w-3--5',
        value: '60%',
      },
      {
        utility: 'w-4--5',
        value: '80%',
      },
      {
        utility: 'w-full',
        value: '100%',
      },
      {
        utility: 'w-vw',
        value: '100vw',
      },
    ],
  },
  {
    link: 'padding',
    name: 'padding',
    scroll: 'scroll',
    property: 'padding',
    example: 'p-0 md-p-2',
    usage: {
      syntax: 'p-{number} , px-{number} or py-{number}',
      nameClass: 'padding',
      properties: ['p-0', 'p-1', 'px-1', 'py-1'],
    },
    values: [
      {
        utility: 'p-0',
        value: '0px',
      },
      {
        utility: 'p-1',
        value: '12px',
      },
      {
        utility: 'p-2',
        value: '24px',
      },
      {
        utility: 'p-3',
        value: '48px',
      },
      {
        utility: 'p-4',
        value: '72px',
      },
      {
        utility: 'p-5',
        value: '96px',
      },
      {
        utility: 'p-auto',
        value: 'auto',
      },
      {
        utility: 'px-0',
        value: '0px',
      },
      {
        utility: 'px-1',
        value: '12px',
      },
      {
        utility: 'px-2',
        value: '24px',
      },
      {
        utility: 'px-3',
        value: '48px',
      },
      {
        utility: 'px-4',
        value: '72px',
      },
      {
        utility: 'px-5',
        value: '96px',
      },
      {
        utility: 'px-auto',
        value: 'auto',
      },
      {
        utility: 'py-0',
        value: '0px',
      },
      {
        utility: 'py-1',
        value: '12px',
      },
      {
        utility: 'py-2',
        value: '24px',
      },
      {
        utility: 'py-3',
        value: '48px',
      },
      {
        utility: 'py-4',
        value: '72px',
      },
      {
        utility: 'py-5',
        value: '96px',
      },
      {
        utility: 'py-auto',
        value: 'auto',
      },
      {
        utility: 'pr-0',
        value: '0px',
      },
      {
        utility: 'pr-1',
        value: '12px',
      },
      {
        utility: 'pr-2',
        value: '24px',
      },
      {
        utility: 'pr-3',
        value: '48px',
      },
      {
        utility: 'pr-4',
        value: '72px',
      },
      {
        utility: 'pr-5',
        value: '96px',
      },
      {
        utility: 'pt-0',
        value: '0px',
      },
      {
        utility: 'pt-1',
        value: '12px',
      },
      {
        utility: 'pt-2',
        value: '24px',
      },
      {
        utility: 'pt-3',
        value: '48px',
      },
      {
        utility: 'pt-4',
        value: '72px',
      },
      {
        utility: 'pt-5',
        value: '96px',
      },
      {
        utility: 'pl-0',
        value: '0px',
      },
      {
        utility: 'pl-1',
        value: '12px',
      },
      {
        utility: 'pl-2',
        value: '24px',
      },
      {
        utility: 'pl-3',
        value: '48px',
      },
      {
        utility: 'pl-4',
        value: '72px',
      },
      {
        utility: 'pl-5',
        value: '96px',
      },
      {
        utility: 'pb-0',
        value: '0px',
      },
      {
        utility: 'pb-1',
        value: '12px',
      },
      {
        utility: 'pb-2',
        value: '24px',
      },
      {
        utility: 'pb-3',
        value: '48px',
      },
      {
        utility: 'pb-4',
        value: '72px',
      },
      {
        utility: 'pb-5',
        value: '96px',
      },
    ],
  },
  {
    link: 'margin',
    name: 'margin',
    property: 'margin',
    scroll: 'scroll',
    example: 'm-0 md-m-2',
    usage: {
      syntax: 'm-{number} , mx-{number} or my-{number}',
      nameClass: 'padding',
      properties: ['m-0', 'm-1', 'mx-1', 'my-1'],
    },
    values: [
      {
        utility: 'm-0',
        value: '0px',
      },
      {
        utility: 'm-1',
        value: '12px',
      },
      {
        utility: 'm-2',
        value: '24px',
      },
      {
        utility: 'm-3',
        value: '48px',
      },
      {
        utility: 'm-4',
        value: '72px',
      },
      {
        utility: 'm-5',
        value: '96px',
      },
      {
        utility: 'm-auto',
        value: 'auto',
      },
      {
        utility: 'mx-0',
        value: '0px',
      },
      {
        utility: 'mx-1',
        value: '12px',
      },
      {
        utility: 'mx-2',
        value: '24px',
      },
      {
        utility: 'mx-3',
        value: '48px',
      },
      {
        utility: 'mx-4',
        value: '72px',
      },
      {
        utility: 'mx-5',
        value: '96px',
      },
      {
        utility: 'mx-auto',
        value: 'auto',
      },
      {
        utility: 'my-0',
        value: '0px',
      },
      {
        utility: 'my-1',
        value: '12px',
      },
      {
        utility: 'my-2',
        value: '24px',
      },
      {
        utility: 'my-3',
        value: '48px',
      },
      {
        utility: 'my-4',
        value: '72px',
      },
      {
        utility: 'my-5',
        value: '96px',
      },
      {
        utility: 'my-auto',
        value: 'auto',
      },
      {
        utility: 'mr-0',
        value: '0px',
      },
      {
        utility: 'mr-1',
        value: '12px',
      },
      {
        utility: 'mr-2',
        value: '24px',
      },
      {
        utility: 'mr-3',
        value: '48px',
      },
      {
        utility: 'mr-4',
        value: '72px',
      },
      {
        utility: 'mr-5',
        value: '96px',
      },
      {
        utility: 'mt-0',
        value: '0px',
      },
      {
        utility: 'mt-1',
        value: '12px',
      },
      {
        utility: 'mt-2',
        value: '24px',
      },
      {
        utility: 'mt-3',
        value: '48px',
      },
      {
        utility: 'mt-4',
        value: '72px',
      },
      {
        utility: 'mt-5',
        value: '96px',
      },
      {
        utility: 'ml-0',
        value: '0px',
      },
      {
        utility: 'ml-1',
        value: '12px',
      },
      {
        utility: 'ml-2',
        value: '24px',
      },
      {
        utility: 'ml-3',
        value: '48px',
      },
      {
        utility: 'ml-4',
        value: '72px',
      },
      {
        utility: 'ml-5',
        value: '96px',
      },
      {
        utility: 'mb-0',
        value: '0px',
      },
      {
        utility: 'mb-1',
        value: '12px',
      },
      {
        utility: 'mb-2',
        value: '24px',
      },
      {
        utility: 'mb-3',
        value: '48px',
      },
      {
        utility: 'mb-4',
        value: '72px',
      },
      {
        utility: 'mb-5',
        value: '96px',
      },
    ],
  },
  {
    link: 'display',
    name: 'display',
    property: 'display',
    example: 'display-block md-display-flex',
    usage: {
      syntax: 'display-{value}',
      nameClass: 'display',
      properties: ['display-i', 'display-i-b', 'display-b', 'display-f'],
    },
    values: [
      {
        utility: 'display-none',
        value: 'none',
      },
      {
        utility: 'display-b',
        value: 'block',
      },
      {
        utility: 'display-f',
        value: 'flex',
      },
      {
        utility: 'display-i',
        value: 'inline',
      },
      {
        utility: 'display-i-b',
        value: 'inline-block',
      },
    ],
  },
  {
    link: 'opacity',
    name: 'opacity',
    property: 'opacity',
    example: 'op-0 sm-op-20 md-op-40 lg-op-60 xl-op-100',
    usage: {
      syntax: 'op-{number}0',
      nameClass: 'opacity',
      properties: ['op-20', 'op-40', 'op-60', 'op-80', 'op-100'],
    },
    values: [
      {
        utility: 'op-0',
        value: 0,
      },
      {
        utility: 'op-10',
        value: 0.1,
      },
      {
        utility: 'op-20',
        value: 0.2,
      },
      {
        utility: 'op-30',
        value: 0.3,
      },
      {
        utility: 'op-40',
        value: 0.4,
      },
      {
        utility: 'op-50',
        value: 0.5,
      },
      {
        utility: 'op-60',
        value: 0.6,
      },
      {
        utility: 'op-70',
        value: 0.7,
      },
      {
        utility: 'op-80',
        value: 0.8,
      },
      {
        utility: 'op-90',
        value: 0.9,
      },
      {
        utility: 'op-100',
        value: 1,
      },
    ],
  },
  {
    link: 'borderRadius',
    name: 'border Radius',
    property: 'border-radius',
    example:
      'radius-none sm-radius-sm md-radius-lg lg-radius-xl xl-radius-full',
    usage: {
      syntax: 'radius-{value}',
      nameClass: 'radius',
      properties: ['radius-sm', 'radius-md', 'radius-xl', 'radius-full'],
    },
    values: [
      {
        utility: 'radius (default)',
        value: '5px',
      },
      {
        utility: 'radius-none',
        value: '0px',
      },
      {
        utility: 'radius-xs',
        value: '2.5px',
      },
      {
        utility: 'radius-sm',
        value: '3.75px',
      },
      {
        utility: 'radius-base',
        value: '6.25px',
      },
      {
        utility: 'radius-md',
        value: '10px',
      },
      {
        utility: 'radius-lg',
        value: '15px',
      },
      {
        utility: 'radius-xl',
        value: '20px',
      },
    ],
  },
  {
    link: 'flex',
    name: 'flex',
    property: 'flex',
    scroll: 'scroll',
    example: '',
    usage: {
      syntax: 'justify-{value} , align-{value} or flex-{value}',
      nameClass: 'flex',
      properties: [
        'justify-center',
        'justify-between',
        'align-center',
        'align-start',
        'flex-column',
        'flex-cr',
      ],
    },
    values: [
      {
        utility: 'justify-center',
        value: 'center',
      },
      {
        utility: 'justify-between',
        value: 'space-between',
      },
      {
        utility: 'justify-evenly',
        value: 'space-evenly',
      },
      {
        utility: 'justify-around',
        value: 'space-around',
      },
      {
        utility: 'justify-end',
        value: 'flex-end',
      },
      {
        utility: 'justify-start',
        value: 'flex-start',
      },
      {
        utility: 'align-center',
        value: 'center',
      },

      {
        utility: 'align-end',
        value: 'flex-end',
      },
      {
        utility: 'align-start',
        value: 'flex-start',
      },
      {
        utility: 'flex-row',
        value: 'row',
      },
      {
        utility: 'flex-column',
        value: 'column',
      },
      {
        utility: 'flex-cr',
        value: 'row-reverse',
      },
      {
        utility: 'flex-rr',
        value: 'row-reverse',
      },
    ],
  },
  {
    link: 'shadows',
    name: 'box Shadow',
    property: 'box-shadow',
    example:
      'shadow-none sm-shadow-sm md-shadow-lg lg-shadow-xl xl-shadow-full',
    usage: {
      syntax: 'shadow-{value}',
      nameClass: 'shadow',
      properties: ['shadow-xs', 'shadow-md', 'shadow-lg', 'shadow-xl'],
    },
    values: [
      {
        utility: 'shadow-none',
        value: 'none',
      },
      {
        utility: 'shadow-xs',
        value:
          'rgba(60, 64, 67, 0.45) 0px 1px 2px 0px, rgba(60, 64, 67, 0.3) 0px 2px 6px 2px',
      },
      {
        utility: 'shadow-sm',
        value: 'rgba(0, 0, 0, 0.4) 0px 3px 6px, rgba(0, 0, 0, 0.3) 0px 3px 6px',
      },
      {
        utility: 'shadow-base',
        value:
          'rgba(0, 0, 0, 0.3) 0px 10px 20px, rgba(0, 0, 0, 0.25) 0px 6px 6px',
      },
      {
        utility: 'shadow-md',
        value:
          'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
      },
      {
        utility: 'shadow-lg',
        value:
          'rgba(0, 0, 0, 0.25) 0px 16px 32px, rgba(0, 0, 0, 0.21) 0px 12px 12px',
      },
      {
        utility: 'shadow-xl',
        value:
          'rgba(0, 0, 0, 0.22) 0px 19px 38px, rgba(0, 0, 0, 0.31) 0px 15px 12px',
      },
      {
        utility: 'shadow-2xl',
        value: '#26394d 0px 20px 30px -10px',
      },
    ],
  },
  {
    link: 'display',
    name: 'display',
    property: 'display',
    example: 'display-block md-display-flex',
    usage: {
      syntax: 'display-{value}',
      nameClass: 'display',
      properties: ['display-i', 'display-i-b', 'display-b', 'display-f'],
    },
    values: [
      {
        utility: 'display-none',
        value: 'none',
      },
      {
        utility: 'display-b',
        value: 'block',
      },
      {
        utility: 'display-f',
        value: 'flex',
      },
      {
        utility: 'display-i',
        value: 'inline',
      },
      {
        utility: 'display-i-b',
        value: 'inline-block',
      },
    ],
  },
  {
    link: 'visibility',
    name: 'visibility',
    property: 'visibility',
    usage: {
      syntax: '.hidden .visible',
      nameClass: 'visibility',
      properties: ['hidden', 'visible'],
    },
    values: [
      {
        utility: 'visible',
        value: 'visible',
      },
      {
        utility: 'hidden',
        value: 'hidden',
      },
    ],
  },
];
export default utilities;
